import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { UpdateInvestigationLinkTypeCommand } from './update-investigation-link-type.command';
import { UpdateInvestigationLinkTypeResult } from './update-investigation-link-type.result';

export type { UpdateInvestigationLinkTypeCommand } from './update-investigation-link-type.command';
export type { UpdateInvestigationLinkTypeResult } from './update-investigation-link-type.result';

@Injectable({ providedIn: 'root' })
export class UpdateInvestigationLinkTypeUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(command: UpdateInvestigationLinkTypeCommand): Observable<UpdateInvestigationLinkTypeResult> {
    return this._repository.updateInvestigationLinkType(
      command.investigationId,
      command.linkedInvestigationId,
      command.linkType,
    ).pipe(
      map(() => ({ success: true })),
      catchError((error) => throwError(() => error)),
    );
  }
}
